import { ModalType, useModals } from '@frontend/modal';
import { NotificationContent } from '@frontend/notification/types';
import { useIntl } from 'react-intl';

import { ContentPreview } from './content-preview/content-preview.component';

export interface PreviewButtonProps {
    content: NotificationContent;
    subject: string;
    body: string;
    isDirty: boolean;
}

export const PreviewButton = (props: PreviewButtonProps) => {
    const { openModal, closeModal } = useModals();
    const intl = useIntl();
    const previewModalId = 'notification-preview-modal';
    const label = props.isDirty
        ? intl.formatMessage({
              id: 'content-detail.editor.preview-draft',
              description: 'Button label for opening a local draft preview of unsaved notification content',
              defaultMessage: 'Preview draft'
          })
        : intl.formatMessage({
              id: 'content-detail.editor.preview-saved',
              description: 'Button label for opening the saved backend-rendered preview of notification content',
              defaultMessage: 'Preview saved version'
          });

    return (
        <button
            className='text-brand-primary hover:bg-brand-light hover:text-brand-secondary inline-flex items-center justify-center rounded-md px-4 py-3 font-medium'
            type='button'
            aria-label={label}
            title={label}
            onClick={() =>
                openModal(
                    previewModalId,
                    () => (
                        <ContentPreview
                            onClose={() => closeModal(previewModalId)}
                            content={props.content}
                            draft={props.isDirty ? { subject: props.subject, body: props.body } : null}
                        />
                    ),
                    {},
                    { type: ModalType.PROMPT, className: 'w-[calc(100%_-_2rem)]! max-w-[1100px]! overflow-hidden' }
                )
            }>
            {label}
        </button>
    );
};
